import { getValue } from '@model/utils/getters';
import { find } from 'lodash';

export const mapIdSlugCollection = (ids: any, collection?: Partial<{ id: number; slug: string }>[]) => {
    collection = collection ?? [];
    ids = ids ?? [];

    return ids.map((value) => {
        const itemById = find(collection, ['id', getValue(value, 'id')]);
        const itemBySlug = find(collection, ['slug', getValue(value, 'slug')]);

        if (itemById) {
            return itemById.id;
        } else if (itemBySlug) {
            return itemBySlug.id;
        }

        return value;
    });
};
